module.exports = __webpack_public_path__ + "static/infrared-report-94dcc53567fb14dd5f92636697db15fc.pdf";